(() => {
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#aluma-buy"]');
    if (!link) return;
    const target = document.getElementById('aluma-buy');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({behavior: 'smooth', block: 'start'});
  });
  function init(scope = document) {
    scope.querySelectorAll('[data-ship-date]').forEach(el => {
      const date = new Date(); date.setDate(date.getDate() + 2);
      el.textContent = new Intl.DateTimeFormat('en-US',{weekday:'short',month:'short',day:'numeric'}).format(date);
    });
    scope.querySelectorAll('[data-aluma-menu]').forEach(button => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const menu = document.getElementById(button.getAttribute('aria-controls'));
        if (!menu) return;
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!expanded)); menu.hidden = expanded;
      });
    });
    scope.querySelectorAll('[data-before-after]').forEach(compare => {
      if (compare.dataset.ready) return;
      compare.dataset.ready = 'true';
      const range = compare.querySelector('[data-reveal-range]');
      const paint = () => {
        compare.style.setProperty('--reveal', range.value + '%');
        range.setAttribute('aria-valuetext', range.value + ' percent of the before image visible');
      };
      range.addEventListener('input', paint);
      function move(event) {
        const rect = compare.getBoundingClientRect();
        if (!rect.width) return;
        range.value = Math.round(Math.max(0, Math.min(100, (event.clientX - rect.left) / rect.width * 100)));
        paint();
      }
      range.addEventListener('pointerdown', event => {
        event.preventDefault(); range.focus({preventScroll:true});
        range.setPointerCapture?.(event.pointerId); range.dataset.dragging = 'true'; move(event);
      });
      range.addEventListener('pointermove', event => { if (range.dataset.dragging === 'true') move(event); });
      ['pointerup','pointercancel','lostpointercapture'].forEach(type => range.addEventListener(type, () => { range.dataset.dragging = 'false'; }));
      paint();
    });
    scope.querySelectorAll('[data-aluma-countdown]').forEach(timer => {
      if (timer.dataset.ready) return;
      timer.dataset.ready = 'true';
      const duration = 6 * 60 * 60 * 1000;
      window.alumaVisitTimerEnd ||= Date.now() + duration;
      const value = timer.querySelector('[data-countdown-value]');
      function tick() {
        if (Date.now() >= window.alumaVisitTimerEnd) window.alumaVisitTimerEnd = Date.now() + duration;
        const seconds = Math.ceil((window.alumaVisitTimerEnd - Date.now()) / 1000);
        value.textContent = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60].map(n => String(n).padStart(2, '0')).join(':');
        ['hour','minute','second'].forEach((part,i) => { const el=timer.querySelector('[data-countdown-'+part+']'); if(el) el.textContent=value.textContent.split(':')[i]; });
      }
      tick(); const interval = setInterval(() => { if (!timer.isConnected) clearInterval(interval); else tick(); }, 1000);
    });
    scope.querySelectorAll('[data-aluma-product]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const thumbs = Array.from(root.querySelectorAll('[data-gallery-image]'));
      const mainImage = root.querySelector('.aluma-main-image');
      let currentImage = 0;
      function showImage(index) {
        if (!thumbs.length) return;
        currentImage = (index + thumbs.length) % thumbs.length;
        mainImage.removeAttribute('srcset'); mainImage.src = thumbs[currentImage].dataset.galleryImage;
        mainImage.alt = thumbs[currentImage].dataset.galleryAlt || 'ALUMA fountain';
        if (thumbs[currentImage].dataset.previewGallery) mainImage.dataset.previewImage = thumbs[currentImage].dataset.previewGallery;
        thumbs.forEach((thumb, n) => thumb.setAttribute('aria-current', String(n === currentImage)));
      }
      thumbs.forEach((thumb, n) => thumb.addEventListener('click', () => showImage(n)));
      root.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showImage(currentImage - 1));
      root.querySelector('[data-gallery-next]')?.addEventListener('click', () => showImage(currentImage + 1));
      let touchStart;
      mainImage?.addEventListener('touchstart', event => { touchStart = event.touches[0].clientX; }, {passive:true});
      mainImage?.addEventListener('touchend', event => { const delta = event.changedTouches[0].clientX - touchStart; if (Math.abs(delta) > 45) showImage(currentImage + (delta < 0 ? 1 : -1)); }, {passive:true});
      const sizeDialog = root.querySelector('.aluma-size-dialog');
      root.querySelector('[data-size-open]')?.addEventListener('click', () => sizeDialog.showModal());
      root.querySelector('[data-size-close]')?.addEventListener('click', () => sizeDialog.close());
      const dataElement = root.querySelector('[data-aluma-product-data]');
      const form = root.querySelector('[data-aluma-form]');
      const sticky = document.querySelector('[data-aluma-sticky]');
      if (dataElement && form) {
        const data = JSON.parse(dataElement.textContent);
        form.querySelector('input[name=id]').disabled = false;
        const groups = Array.from(form.querySelectorAll('[data-option-index]'));
        const modes = Array.from(form.querySelectorAll('[data-purchase-mode]'));
        const subscription = modes.find(input => input.value === 'subscription');
        if (subscription) subscription.disabled = !data.refill?.ready;
        const submit = form.querySelector('[type=submit]');
        const label = form.querySelector('[data-atc-label]');
        const format = value => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:data.currency || 'USD'}).format(value / 100);
        let variant, valid = false, adding = false;
        const isSubscription = () => true;
        function updateVariant(changed) {
          const choices = groups.map(group => group.querySelector('input:checked')?.value);
          variant = groups.length ? data.variants.find(v => v.eligible !== false && v.options.every((value, i) => value === choices[i])) : data.variants.find(v => v.eligible !== false);
          const recurring = isSubscription();
          valid = Boolean(variant?.available && !data.requiresSellingPlan && (!recurring || data.refill?.ready));
          submit.disabled = !valid || adding;
          label.textContent = adding ? 'ADDING…' : !variant ? 'UNAVAILABLE' : !variant.available ? 'SOLD OUT' : !valid ? 'UNAVAILABLE' : 'ADD TO CART →';
          form.querySelector('input[name=id]').value = variant?.id || '';
          form.querySelector('[data-price]').textContent = variant ? format(variant.price) : 'Unavailable';
          form.querySelectorAll('[data-bundle-price]').forEach(el => { el.textContent = variant ? format(variant.price) : 'Unavailable'; });
          const price = variant?.price || 0, comparison = Math.max(variant?.compare_at_price || 0, price) + (data.giftValue || 0);
          const fountainCompare = form.querySelector('[data-fountain-compare]');
          fountainCompare.textContent = format(variant?.compare_at_price || 0); fountainCompare.hidden = !variant || variant.compare_at_price <= price;
          form.querySelector('[data-fountain-price]').textContent = variant ? format(price) : 'Unavailable';
          const stock = form.querySelector('[data-stock-status]');
          const low = variant?.inventoryManaged && variant.inventoryPolicy === 'deny' && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= 10;
          stock.replaceChildren();
          if (low) stock.append(document.createElement('i'));
          stock.append(document.createTextNode(!variant?.available ? 'Sold out' : 'Low stock available'));
          const compare = form.querySelector('[data-compare]'); compare.textContent = format(comparison); compare.hidden = comparison <= price;
          const saving = form.querySelector('[data-saving]'); saving.textContent = 'SAVE ' + (comparison > price ? Math.round((comparison - price) / comparison * 100) : 0) + '%'; saving.hidden = comparison <= price;

          root.querySelector('[data-refill-summary]').hidden = !recurring;

          const size = groups.filter(g=>!g.hidden).map(g=>g.querySelector('input:checked')?.value).filter(Boolean).join(' / ');
          root.querySelector('[data-kit-size]').textContent = size.match(/\d+\s*L/i)?.[0] || size || 'ALUMA';
          form.querySelector('[data-onetime-gift]').disabled = recurring;
          if (sticky) {
            sticky.querySelector('[data-sticky-options]').textContent = size;
            sticky.querySelector('[data-sticky-price]').textContent = variant ? format(price) : 'Unavailable';
            const oldPrice = sticky.querySelector('[data-sticky-compare]');oldPrice.textContent = format(comparison);oldPrice.hidden = comparison <= price;
            const button = sticky.querySelector('[data-sticky-submit]'); button.disabled = !valid || adding; button.textContent = adding ? 'ADDING…' : 'ADD TO CART →';
          }
          if (changed && variant) {
            if (variant.image) {
              const found = thumbs.findIndex(thumb => thumb.dataset.galleryImage === variant.image);
              if (found >= 0) showImage(found);
              else { mainImage.removeAttribute('srcset'); mainImage.src = variant.image; }
            }
            if (root.dataset.productPage === 'true') { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
          }
        }
        form.alumaItems = () => {
          if (!valid || !variant) throw new Error('Choose an available fountain and purchase option.');
          const items = [{id:variant.id,quantity:1,properties:{Included:'Dog toys and 5-year fountain warranty'}}];
          if (isSubscription()) {
            if (!data.refill.ready || !data.refill.variantId || !data.refill.planId) throw new Error('This kit is temporarily unavailable. Please try again later.');
            items.push({id:data.refill.variantId,quantity:1,selling_plan:data.refill.planId,properties:{_aluma_filter_refill:'true',Included:'First 2 replacement filters free'}});
          } else items[0].properties = {Included:'Dog toys, 2 free replacement filters, 5-year fountain warranty'};
          return items;
        };
        groups.forEach(group => group.addEventListener('change', () => updateVariant(true)));
        modes.forEach(input => input.addEventListener('change', () => updateVariant(false)));
        updateVariant(false);
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (!valid || adding) return;
          const error = form.querySelector('.aluma-form-error'); error.hidden = true;
          const cart = document.querySelector('cart-drawer.aluma-drawer');
          adding = true; updateVariant(false);
          try {
            if (cart?.addForm) { cart.setActiveElement(submit); await cart.addForm(form); }
            else {
              const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:form.alumaItems()})});
              const result = await response.json();
              if (!response.ok || result.status) throw new Error(result.description || 'Could not add this item.');
              window.location.assign(window.routes?.cart_url || '/cart');
            }
          } catch (e) { error.textContent = e.message || 'Could not add this item. Please try again.'; error.hidden = false; }
          finally { adding = false; updateVariant(false); }
        });
      }
      if (sticky) {
        const hero = document.querySelector('[data-aluma-hero]');
        const scrollRoot = root.closest('.aluma-preview-page');
        let scheduled = false;
        function positionSticky() {
          scheduled = false;
          const viewport = scrollRoot ? scrollRoot.getBoundingClientRect() : {top:0,bottom:window.innerHeight};
          const purchase = root.getBoundingClientRect();
          const pastHero = !hero || hero.getBoundingClientRect().bottom <= viewport.top;
          const insidePurchase = purchase.top < viewport.bottom && purchase.bottom > viewport.top;
          const visible = pastHero && !insidePurchase;
          sticky.hidden = !visible; sticky.classList.toggle('visible', visible);
        }
        const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(positionSticky); } };
        (scrollRoot || window).addEventListener('scroll', schedule, {passive:true});
        window.addEventListener('resize', schedule, {passive:true});
        if ('ResizeObserver' in window) { const observer = new ResizeObserver(schedule); observer.observe(root); if (hero) observer.observe(hero); }
        positionSticky();
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
